<template>
  <div class="template-wrapper bg-light">
    <table class="customer-info-table">
      <tbody>
        <tr>
          <th colspan="2" class="customer-name" v-html="message.AttachmentFile.Payload.FirstName + ' ' +message.AttachmentFile.Payload.LastName"></th>
        </tr>
        <tr>
          <td colspan="2" class="customer-email" v-html="message.AttachmentFile.Payload.Email"></td>
        </tr>
        <tr v-if="message.AttachmentFile.Payload.VehicleDesc1 || message.AttachmentFile.Payload.VehicleDesc2">
          <th colspan="2" class="customer-vehicle-info section-header">
            <img src="static/assets/img/vehicle_icon.svg" class="section-icon">VEHICLE(S)
            <div class="customer-alerts">
              <div class="chat-message-customer-alert" style="background-color: #ef3745;" title="Upgrade Alert" v-show="hasAlert('A')">A</div>
              <div class="chat-message-customer-alert" style="background-color: #82431d;" title="Flex Alert" v-show="hasAlert('F')">F</div>
              <div class="chat-message-customer-alert" style="background-color: #41af49;" title="Service Alert" v-show="hasAlert('S')">S</div>
              <div class="chat-message-customer-alert" style="background-color: #2a8140;" title="Service Appointment" v-show="hasAlert('P')">P</div>
              <div class="chat-message-customer-alert" style="background-color: #f37025;" title="Mileage Alert" v-show="hasAlert('M')">M</div>
              <div class="chat-message-customer-alert" style="background-color: #7562ab;" title="Warranty Alert" v-show="hasAlert('W')">W</div>
              <div class="chat-message-customer-alert" style="background-color: #436cb4;" title="Contract End Alert" v-show="hasAlert('C')">C</div>
              <div class="chat-message-customer-alert" style="background-color: #faaf24;" title="In-Market Alert" v-show="hasAlert('I')">I</div>
              <div class="chat-message-customer-alert" style="background-color: #faaf24;" title="In-Market Engaged Alert" v-show="hasAlert('E')">E</div>
            </div>
          </th>
        </tr>
        <tr v-show="message.AttachmentFile.Payload.VehicleDesc1">
          <td colspan="2" class="vehicle-description-1" v-html="message.AttachmentFile.Payload.VehicleDesc1"></td>
        </tr>
        <tr v-show="message.AttachmentFile.Payload.VehicleDesc2" class="vehicle-description-2">
          <td colspan="2" class="vehicle-description-2" v-html="message.AttachmentFile.Payload.VehicleDesc2"></td>
        </tr>
        <tr>
          <th colspan="2" class="section-header">
            <img src="static/assets/img/location_icon.svg" class="section-icon">ADDRESS</th>
        </tr>
        <tr>
          <td class="section-item first-item">City</td>
          <th class="section-item item-value first-item" v-html="message.AttachmentFile.Payload.City ? message.AttachmentFile.Payload.City : '-'"></th>
        </tr>
        <tr>
          <td class="section-item">State</td>
          <th class="section-item item-value" v-html="message.AttachmentFile.Payload.State ? message.AttachmentFile.Payload.State : '-'"></th>
        </tr>
        <tr>
          <th colspan="2" class="section-header">
            <img src="static/assets/img/phone_icon.svg" class="section-icon">PHONE(S)</th>
        </tr>
        <tr>
          <td class="section-item first-item">Cell</td>
          <th class="section-item item-value first-item" v-html="message.AttachmentFile.Payload.CellPhone ? message.AttachmentFile.Payload.CellPhone : '-'"></th>
        </tr>
        <tr>
          <td class="section-item">Home</td>
          <th class="section-item item-value" v-html="message.AttachmentFile.Payload.HomePhone ? message.AttachmentFile.Payload.HomePhone : '-'"></th>
        </tr>
        <tr>
          <td class="section-item">Work</td>
          <th class="section-item item-value" v-html="message.AttachmentFile.Payload.WorkPhone ? message.AttachmentFile.Payload.WorkPhone : '-'"></th>
        </tr>
        <tr>
          <th colspan="2" class="dealsheet-icon-wrapper">
            <a target="_blank" class="btn btn-sm btn-block primary" :href="customerUrl">
              <img src="static/assets/img/dealsheet_icon.svg" class="section-icon">VIEW DEAL SHEET
            </a>
          </th>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import {DataMiningAlertBlock} from '@/lib/utilities/enums'
  export default {
    name: 'customerPayload',
    data: function () {
      return {
        message: null
      }
    },
    computed: {
      customerUrl() {
        return process.env.DEALSHEET_URL + this.message.AttachmentFile.Payload.EntityId
      },
    },
    created() {
      let vm = this;
      vm.message = vm.$parent._props.message
    },
    methods: {
      hasAlert: function (alertType) {
        try {
          switch (alertType) {
            case "A":
              return (
                this.message.AttachmentFile.Payload.DataMiningAlertBlock &
                vm.DataMiningAlertBlock.A
              );
            case "F":
              return (
                this.message.AttachmentFile.Payload.DataMiningAlertBlock &
                vm.DataMiningAlertBlock.F
              );
            case "S":
              return (
                this.message.AttachmentFile.Payload.DataMiningAlertBlock &
                vm.DataMiningAlertBlock.S
              );
            case "P":
              return (
                this.message.AttachmentFile.Payload.DataMiningAlertBlock &
                vm.DataMiningAlertBlock.P
              );
            case "M":
              return (
                this.message.AttachmentFile.Payload.DataMiningAlertBlock &
                vm.DataMiningAlertBlock.M
              );
            case "W":
              return (
                this.message.AttachmentFile.Payload.DataMiningAlertBlock &
                vm.DataMiningAlertBlock.W
              );
            case "C":
              return (
                this.message.AttachmentFile.Payload.DataMiningAlertBlock &
                vm.DataMiningAlertBlock.C
              );
            case "I":
              return (
                this.message.AttachmentFile.Payload.DataMiningAlertBlock &
                vm.DataMiningAlertBlock.I
              );
            case "E":
              return (
                this.message.AttachmentFile.Payload.DataMiningAlertBlock &
                vm.DataMiningAlertBlock.E
              );
            default:
              return false;
          }
        } catch (err) {
          return false;
        }
      },
    }
  }

</script>

<style lang="scss" scoped>
.template-wrapper {
  border-radius:$Border-radius;
  margin-top: 5px;
  color: #808080;
  padding: 5px;
  width: 300px;

  .customer-info-table {
    width: 100%;


    .customer-name {
      padding: 5px 5px 0px;
      font-size: 15px;
      text-align: left;
      color: $blue-lt;
    }

    .customer-email {
      padding: 0px 5px 10px;
      color: $blue-lt;
    }

    .section-header {
      padding: 5px 0px;
      border-bottom: 1px solid #d5d5d5;
    }

    .section-icon {
      width: 20px;
      margin-right: 5px;
    }

    .section-item {
      padding: 0px 5px 5px;

      &.item-value {
        color: #555555;
      }

      &.first-item {
        padding: 5px !important;
      }
    }

    .customer-vehicle-info {
      .customer-alerts {
        float: right;

        .chat-message-customer-alert {
          width: 18px;
          text-align: center;
          border-radius: 5px;
          color: #ffffff;
          margin-left: 1px;
          display: inline-block;
        }
      }
    }

    .vehicle-description-1 {
      padding: 5px;
      color: #555555;
    }

    .vehicle-description-2 {
      padding: 0px 5px 5px;
      color: #555555;
    }

    .dealsheet-icon-wrapper {
      padding: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Messenger/MessageList/Message/MessageAttachment/CustomerPayload.vue